module.exports = __webpack_public_path__ + "static/media/undraw_export_files_re_99ar.349ba07f.png";